import React, { useRef, useState } from 'react'

//Node Modules
import {Overlay, Popover} from 'react-bootstrap'

//Components
import LinkButton from 'components/LinkButton'

//Styles
import styles from './Glossary.module.scss'

interface Props {
  id: string
  term: React.ReactNode
  content: React.ReactNode,
  label: string
}

const Glossary = ({id, term, content,label}:Props) => {  
  const glossary = useRef(null)
  const [show, setShow] = useState(false)

  const openGlossary = (e: React.SyntheticEvent) => {
    setShow(!show)
  }

  const popover = (
    <Popover id={`glossary-${id}`}>
      <Popover.Content bsPrefix={styles.glossaryBody}>
        {content}
      </Popover.Content>
    </Popover>
  )

  return (
    <span ref={glossary} aria-live="polite">
      <LinkButton className={styles.term}  onClick={openGlossary} aria-label={label}>
        {term}
      </LinkButton>
      <Overlay target={glossary.current} show={show} rootClose onHide={() => setShow(false)} container={glossary.current}>
        {popover}
      </Overlay>
    </span>
  )
}

export default Glossary